const Lines = ({ x, y, widths }) =>
  widths.map((w, i) => <rect key={i} x={x} y={y + i * 14} width={w} height="4" rx="2" fill="#ffffff" fillOpacity="0.1" />);

const DocStack = () => (
  <svg viewBox="0 0 320 220" className="w-full h-auto" aria-hidden="true">
    <rect x="70" y="40" width="130" height="160" rx="12" fill="#0b0b0d" stroke="#1e2024" transform="rotate(-8 135 120)" />
    <rect x="110" y="30" width="130" height="160" rx="12" fill="#0b0b0d" stroke="#2a2d33" transform="rotate(5 175 110)" />
    <g>
      <rect x="95" y="24" width="130" height="170" rx="12" fill="#09090b" stroke="#00e5ff" strokeOpacity="0.45" />
      <rect x="111" y="42" width="56" height="6" rx="3" fill="#ffffff" fillOpacity="0.5" />
      <Lines x={111} y={64} widths={[98, 84, 92, 70, 88, 60]} />
      <rect x="111" y="160" width="40" height="16" rx="8" fill="none" stroke="#00e5ff" strokeOpacity="0.7" />
      <path d="M124 168 l4 4 l8 -8" fill="none" stroke="#00e5ff" strokeWidth="1.5" />
      <rect x="99" y="40" width="122" height="2" fill="#00e5ff" opacity="0.7" className="anim-scan" style={{ filter: "drop-shadow(0 0 6px #00e5ff)" }} />
    </g>
  </svg>
);

const ShieldDoc = () => (
  <svg viewBox="0 0 320 220" className="w-full h-auto" aria-hidden="true">
    <rect x="70" y="30" width="130" height="165" rx="12" fill="#09090b" stroke="#2a2d33" />
    <rect x="86" y="48" width="50" height="6" rx="3" fill="#ffffff" fillOpacity="0.45" />
    <Lines x={86} y={70} widths={[96, 80, 90, 66, 84]} />
    <circle cx="210" cy="140" r="52" fill="none" stroke="#00e5ff" strokeOpacity="0.18" className="anim-pulse" />
    <path d="M210 98 L244 110 V138 C244 160 230 174 210 182 C190 174 176 160 176 138 V110 Z" fill="#050505" stroke="#00e5ff" strokeOpacity="0.85" strokeWidth="1.5" style={{ filter: "drop-shadow(0 0 8px rgba(0,229,255,0.4))" }} />
    <path d="M196 140 l10 10 l18 -20" fill="none" stroke="#00e5ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DocVisual = ({ variant }) => (
  <div className="glass rounded-[24px] p-6 sm:p-10" data-testid={`doc-visual-${variant}`}>
    {variant === "moduli" ? <DocStack /> : <ShieldDoc />}
  </div>
);
